import { ActionContext } from 'vuex';

import { TBaseFilterPayload } from '@/common/types/filter';
import { getLocalState } from '@/common/utils/store';

import { TProductAggregatedFilter } from '../../types/product-aggregated';
import { PRODUCT_AGGREGATED_ACTIONS_NAME } from './name';
import { TProductAggregatedState } from './types';

import { TPaginationParams } from '@/types/meta';
import links from '@/utils/links';
import request from '@/utils/request';

export async function searchProductAggregated(
  context: ActionContext<TProductAggregatedState, unknown>,
  payload: TBaseFilterPayload<TPaginationParams<TProductAggregatedFilter>>,
) {
  return request(
    context,
    {
      url: links.ved.productAggregated.getProductAggregated,
      name: getLocalState(PRODUCT_AGGREGATED_ACTIONS_NAME.searchProductAggregated),
      abortController: payload.abortController,
      method: 'post',
    },
    payload.params,
  );
}
